<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ListICCIDS />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ListICCIDS from '@/components/settings/consults/iccid/List.vue'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'ListICCID',
  components: {
    PageTitle,
    PageRowWrapper,
    ListICCIDS,
    LoadingPage
  }
}
</script>